var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-checkboxes',{attrs:{"name":_vm.data.slug,"slug":_vm.data.slug,"label":_vm.data.label,"value":_vm.data.value || [],"values":_vm.data.values && typeof _vm.data === 'object' ? _vm.data.values : {}}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15abce4a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/extensions/rubinred/catalog/assets/js/components/CatalogAttributeFilter.vue
// module id = 28Ex
// module chunks = 0